// ======================================================================
// FILE:
// src/modules/service_crm/reports/pages/SatisfactionAnalysisReportPage.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Satisfaction Analysis Report
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import Select from "react-select";

import reportService
from "../services/reportService";

import businessPartnerService
from "../../../ppe/pages/masters/business_partner/services/businessPartnerService";

export default function SatisfactionAnalysisReportPage() {

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [total, setTotal] =
    useState(0);

  const [customerOptions,
    setCustomerOptions] =
    useState([]);

  const [kpis, setKpis] =
    useState({

      total_surveys: 0,

      average_satisfaction: 0,

      satisfied: 0,

      neutral: 0,

      dissatisfied: 0,

      recommend: 0,

    });

  const [filters, setFilters] =
    useState({

      search: "",

      customer_name: "",

      ticket_no: "",

      assigned_engineer: "",

      followup_executive: "",

      satisfaction_status: "ALL",

      from_date: "",

      to_date: "",

      page: 1,

      page_size: 20,

    });

  useEffect(() => {

    loadCustomers();

    loadData();

  }, [filters.page]);

  async function loadCustomers() {

    try {

      const rows =
        await businessPartnerService
          .getCustomerLookup();

      setCustomerOptions(

        (rows || []).map(
          (row) => ({

            value:
              row.bp_name,

            label:
              `${row.bp_code} - ${row.bp_name}`,

          })
        )

      );

    } catch (err) {

      console.error(err);

    }

  }

  async function loadData() {

    try {

      setLoading(true);

      const data =
        await reportService
          .getSatisfactionAnalysisReport(
            filters
          );

      setRows(
        data?.rows || []
      );

      setTotal(
        data?.total || 0
      );

      setKpis(
        data?.kpis || {}
      );

    } catch (err) {

      console.error(err);

      alert(
        "Failed to load report"
      );

    } finally {

      setLoading(false);

    }

  }

  async function handleExportExcel() {

    try {

      const blob =
        await reportService
          .exportSatisfactionAnalysisExcel(
            filters
          );

      const url =
        window.URL.createObjectURL(
          new Blob([blob])
        );

      const link =
        document.createElement("a");

      link.href = url;

      link.setAttribute(
        "download",
        "satisfaction_analysis_report.xlsx"
      );

      document.body.appendChild(
        link
      );

      link.click();

      link.remove();

    } catch (err) {

      console.error(err);

      alert(
        "Export failed"
      );

    }

  }

  function handleFilterChange(e) {

    setFilters({

      ...filters,

      [e.target.name]:
        e.target.value,

    });

  }

  function handleSearch() {

    setFilters({

      ...filters,

      page: 1,

    });

    loadData();

  }

  function handleReset() {

    setFilters({

      search: "",

      customer_name: "",

      ticket_no: "",

      assigned_engineer: "",

      followup_executive: "",

      satisfaction_status: "ALL",

      from_date: "",

      to_date: "",

      page: 1,

      page_size: 20,

    });

  }

  function renderStatusBadge(
    value
  ) {

    let cls =
      "bg-secondary";

    if (
      value === "SATISFIED"
    ) {
      cls = "bg-success";
    }

    else if (
      value === "NEUTRAL"
    ) {
      cls = "bg-warning";
    }

    else if (
      value === "DISSATISFIED"
    ) {
      cls = "bg-danger";
    }

    return (

      <span
        className={`badge ${cls}`}
      >
        {value}
      </span>

    );

  }

  const KPI_CARD = (
    title,
    value,
    bg
  ) => (

    <div
      style={{
        background: bg,
        color: "#fff",
        borderRadius: 12,
        padding: 16,
      }}
    >

      <div
        style={{
          fontSize: 12,
          opacity: 0.9,
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontSize: 26,
          fontWeight: 700,
        }}
      >
        {value}
      </div>

    </div>

  );

  return (

    <div>

      {/* HEADER */}

      <div
        style={{
          marginBottom: 20,
        }}
      >

        <h2>
          Satisfaction Analysis Report
        </h2>

        <div
          style={{
            color: "#6c757d",
          }}
        >
          Customer satisfaction analytics and reporting
        </div>

      </div>

      {/* KPI */}

      <div
        style={{

          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit,minmax(180px,1fr))",

          gap: 14,

          marginBottom: 20,

        }}
      >

        {KPI_CARD(
          "Total Surveys",
          kpis.total_surveys || 0,
          "#2563eb"
        )}

        {KPI_CARD(
          "Avg Satisfaction %",
          kpis.average_satisfaction || 0,
          "#111827"
        )}

        {KPI_CARD(
          "Satisfied",
          kpis.satisfied || 0,
          "#16a34a"
        )}

        {KPI_CARD(
          "Neutral",
          kpis.neutral || 0,
          "#f59e0b"
        )}

        {KPI_CARD(
          "Dissatisfied",
          kpis.dissatisfied || 0,
          "#dc2626"
        )}

        {KPI_CARD(
          "Recommend",
          kpis.recommend || 0,
          "#7c3aed"
        )}

      </div>

      {/* FILTERS */}

      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          padding: 16,
          marginBottom: 20,
          boxShadow:
            "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: 14,
          }}
        >

          <input
            className="form-control"
            placeholder="Search"
            name="search"
            value={filters.search}
            onChange={handleFilterChange}
          />

          <Select
            options={
              customerOptions
            }
            isSearchable
            isClearable
            placeholder="Customer"
            value={
              customerOptions.find(
                (x) =>
                  x.value ===
                  filters.customer_name
              ) || null
            }
            onChange={(selected) =>
              setFilters({

                ...filters,

                customer_name:
                  selected?.value || "",

              })
            }
          />

          <input
            className="form-control"
            placeholder="Ticket No"
            name="ticket_no"
            value={filters.ticket_no}
            onChange={handleFilterChange}
          />

          <input
            className="form-control"
            placeholder="Engineer"
            name="assigned_engineer"
            value={
              filters.assigned_engineer
            }
            onChange={handleFilterChange}
          />

          <input
            className="form-control"
            placeholder="Followup Executive"
            name="followup_executive"
            value={
              filters.followup_executive
            }
            onChange={handleFilterChange}
          />

          <select
            className="form-select"
            name="satisfaction_status"
            value={
              filters.satisfaction_status
            }
            onChange={
              handleFilterChange
            }
          >

            <option value="ALL">
              All Status
            </option>

            <option value="SATISFIED">
              SATISFIED
            </option>

            <option value="NEUTRAL">
              NEUTRAL
            </option>

            <option value="DISSATISFIED">
              DISSATISFIED
            </option>

          </select>

          <input
            type="date"
            className="form-control"
            name="from_date"
            value={filters.from_date}
            onChange={handleFilterChange}
          />

          <input
            type="date"
            className="form-control"
            name="to_date"
            value={filters.to_date}
            onChange={handleFilterChange}
          />

        </div>

        <div
          style={{
            marginTop: 16,
            display: "flex",
            gap: 10,
          }}
        >

          <button
            className="btn btn-primary"
            onClick={handleSearch}
          >
            Search
          </button>

          <button
            className="btn btn-secondary"
            onClick={handleReset}
          >
            Reset
          </button>

          <button
            className="btn btn-success"
            onClick={
              handleExportExcel
            }
          >
            Export Excel
          </button>

        </div>

      </div>

      {/* TABLE */}

      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          overflow: "hidden",
          boxShadow:
            "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >

        <div
          style={{
            overflowX: "auto",
          }}
        >

          <table
            className="table table-hover"
          >

            <thead
              className="table-light"
            >

              <tr>

                <th>Ticket No</th>

                <th>Customer</th>

                <th>Engineer</th>

                <th>Executive</th>

                <th>Followup Date</th>

                <th>Overall</th>

                <th>Issue</th>

                <th>Response</th>

                <th>Quality</th>

                <th>Satisfaction %</th>

                <th>Status</th>

                <th>Recommend</th>

                <th>Comments</th>

              </tr>

            </thead>

            <tbody>

              {loading && (

                <tr>

                  <td
                    colSpan="13"
                    className="text-center"
                  >
                    Loading...
                  </td>

                </tr>

              )}

              {!loading &&
                rows.length === 0 && (

                <tr>

                  <td
                    colSpan="13"
                    className="text-center"
                  >
                    No records found
                  </td>

                </tr>

              )}

              {!loading &&
                rows.map((row) => (

                <tr key={row.id}>

                  <td>
                    {row.ticket_no}
                  </td>

                  <td>
                    {row.customer_name}
                  </td>

                  <td>
                    {row.assigned_engineer}
                  </td>

                  <td>
                    {row.followup_executive}
                  </td>

                  <td>
                    {row.followup_date}
                  </td>

                  <td>
                    {row.overall_satisfaction_rating}
                  </td>

                  <td>
                    {row.issue_resolved_rating}
                  </td>

                  <td>
                    {row.response_time_rating}
                  </td>

                  <td>
                    {row.service_quality_rating}
                  </td>

                  <td>
                    {
                      row.satisfaction_percentage
                    }%
                  </td>

                  <td>
                    {renderStatusBadge(
                      row.satisfaction_status
                    )}
                  </td>

                  <td>
                    {
                      row.would_recommend
                        ? "Yes"
                        : "No"
                    }
                  </td>

                  <td>
                    {
                      row.customer_comments
                    }
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

      {/* PAGINATION */}

      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          marginTop: 16,
        }}
      >

        <div>
          Total: {total}
        </div>

        <div
          style={{
            display: "flex",
            gap: 8,
          }}
        >

          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={
              filters.page <= 1
            }
            onClick={() =>
              setFilters({

                ...filters,

                page:
                  filters.page - 1,

              })
            }
          >
            Previous
          </button>

          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={
              rows.length <
              filters.page_size
            }
            onClick={() =>
              setFilters({

                ...filters,

                page:
                  filters.page + 1,

              })
            }
          >
            Next
          </button>

        </div>

      </div>

    </div>

  );

}